import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatInputModule} from '@angular/material/input';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SchoolManagementRoutingModule } from './school-management-routing.module';
import { StaffComponent } from './staff/staff.component';
import { SharedModule } from '../shared/shared.module';
import { SchoolInfoComponent } from './school-info/school-info.component';
import { GradesClassesComponent } from './grades-classes/grades-classes.component';
import { GradeClassCardComponent } from './grade-class-card/grade-class-card.component';
import { AddGradeComponent } from './add-grade/add-grade.component';
import { ClassStudentsTeachersListComponent } from './class-students-teachers-list/class-students-teachers-list.component';
import { GatesComponent } from './gates/gates.component';
import { GateCardComponent } from './gate-card/gate-card.component';
import { AddGateComponent } from './add-gate/add-gate.component';
import { AssignGateModalComponent } from './assign-gate-modal/assign-gate-modal.component';
import { DismissalFlowComponent } from './dismissal-flow/dismissal-flow.component';
import { CreateFlowPopupComponent } from './dismissal-flow/create-flow-popup/create-flow-popup.component';
import { AddStaffComponent } from './add-staff/add-staff.component';
import { NationalIdChoiceDialogComponent } from './add-staff/national-id-choice-dialog/national-id-choice-dialog.component';
import { LinkChipsComponent } from './add-staff/link-chips/link-chips.component';
import { NamesSoundsComponent } from './names-sounds/names-sounds.component';
import {NgxWavesurferModule} from 'ngx-wavesurfer';
import {NgxWavesurferRxjsModule} from 'ngx-wavesurfer-rxjs';
import { RecordModalComponent } from './record-modal/record-modal.component';
import {MatProgressBarModule} from '@angular/material/progress-bar'
import {DragDropModule} from '@angular/cdk/drag-drop';
import { DismissalTimeComponent } from './dismissal-time/dismissal-time.component';
import {ListboxModule} from 'primeng/listbox';
import { SectionsComponent } from './sections/sections.component';
import { AddSectionComponent } from './add-section/add-section.component';
import { InputTextModule } from 'primeng/inputtext';
import {MultiSelectModule} from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { ClassReorderModalComponent } from './grade-class-card/class-reorder-modal/class-reorder-modal.component';
import { PermissionsModule } from '../shared/permissions/permissions.module';

@NgModule({
  imports: [
    CommonModule,
    MatSlideToggleModule,
    NgbTooltipModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatChipsModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    SchoolManagementRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    // NgxWavesurferModule,
    // NgxWavesurferRxjsModule,
    DragDropModule,
    ListboxModule,
    InputTextModule,
    MultiSelectModule,
    DropdownModule,
    PermissionsModule
  ],
  declarations:
    [StaffComponent,
      AddStaffComponent,
      NationalIdChoiceDialogComponent,
      LinkChipsComponent,
      SchoolInfoComponent,
      GradesClassesComponent,
      GradeClassCardComponent,
      AddGradeComponent,
      ClassStudentsTeachersListComponent,
      GatesComponent,
      GateCardComponent,
      AddGateComponent,
      AssignGateModalComponent,
      SchoolInfoComponent,
      GradesClassesComponent,
      GradeClassCardComponent,
      AddGradeComponent,
      ClassStudentsTeachersListComponent,
      DismissalFlowComponent,
      CreateFlowPopupComponent,
      NamesSoundsComponent,
      RecordModalComponent,
      DismissalTimeComponent,
      SectionsComponent,
      AddSectionComponent,
      ClassReorderModalComponent
    ],
  exports:
    [AssignGateModalComponent,
      AddGradeComponent,
      ClassStudentsTeachersListComponent,
      AddGateComponent,
      AddStaffComponent]
})
export class SchoolManagementModule { }
